import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AutoSaveInput from 'modules/core/components/Inputs/AutoSaveInput'
import TextInput from 'modules/core/components/Inputs/Text'
import asyncAction from 'modules/core/lib/asyncAction'

import type CodeForm from 'modules/payroll_integrations/components/Form/form'

interface Props {
  options: Array<Record<string, any>>
  onSubmit: (...args: any[]) => any
  form: CodeForm
}
interface BodyProps {
  options: Array<Record<string, any>>
  forms: CodeForm[]
}

const Item = observer(({ onSubmit, form }: Props) => {
  return (
    <Table.Row>
      <Table.Cell colSpan={4}>
        <Box width="full" alignItems="flexStart" justifyContent="center">
          <Text.Normal>{form.get('codeable_label').value}</Text.Normal>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={4}>
        <Box width="full" alignItems="flexStart" justifyContent="center">
          <Text.Normal>{form.get('codeable_name').value}</Text.Normal>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={4}>
        <AutoSaveInput onSubmit={() => onSubmit(form)}>
          {(params: any) => <TextInput {...params} field={form.get('code')} />}
        </AutoSaveInput>
      </Table.Cell>
    </Table.Row>
  )
})

const Body = ({ forms, options }: BodyProps) => {
  const onSubmit = async (form: CodeForm) => {
    await asyncAction(() => form.submit())
  }

  return (
    <Table.Body>
      {forms.map((form, index) => (
        <Item key={index} onSubmit={onSubmit} form={form} options={options} />
      ))}
    </Table.Body>
  )
}

export default observer(Body)
